import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { captureAttribution } from "./lib/attribution";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import LifeInsurancePage from "./pages/LifeInsurancePage";
import GroupBenefitsPage from "./pages/GroupBenefitsPage";
import FinancialPlanningPage from "./pages/FinancialPlanningPage";
import TfsaInvestmentsPage from "./pages/TfsaInvestmentsPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import BlogPage from "./pages/BlogPage";
import ThankYouPage from "./pages/ThankYouPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import GroupBenefitsReviewPage from "./pages/GroupBenefitsReviewPage";
import BusinessOwnersPage from "./pages/BusinessOwnersPage";
import NotFoundPage from "./pages/NotFoundPage";

// Old URLs that need to redirect to /contact
const contactRedirects = [
  "/blank-1",
  "/blog/page/3",
  "/blog/tags/advance-directive-bc",
  "/blog/tags/bc-employers-benefits",
  "/blog/tags/beneficiary-designations",
  "/book-online",
  "/get-instant-quote",
  "/contact-5",
];

// Standalone marketing landing pages render with no site chrome (nav/footer).
const CHROMELESS_ROUTES = ["/business-owners"];

function AppShell() {
  const location = useLocation();
  const isChromeless = CHROMELESS_ROUTES.includes(location.pathname);

  useEffect(() => {
    captureAttribution();
  }, [location.search]);

  return (
    <div className="font-dm-sans" data-testid="mayker-website">
      {!isChromeless && <Navigation />}
      <main>
        <Routes>
          {/* Standalone paid-traffic landing page (no site nav/footer) */}
          <Route path="/business-owners" element={<BusinessOwnersPage />} />

          <Route path="/" element={<HomePage />} />
          <Route path="/life-insurance" element={<LifeInsurancePage />} />
          <Route path="/group-benefits" element={<GroupBenefitsPage />} />
          <Route path="/financial-planning" element={<FinancialPlanningPage />} />
          <Route path="/tfsa-investments" element={<TfsaInvestmentsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/group-benefits-review" element={<GroupBenefitsReviewPage />} />

          {/* Redirects for old URLs */}
          {contactRedirects.map((oldPath) => (
            <Route
              key={oldPath}
              path={oldPath}
              element={<Navigate to="/contact" replace />}
            />
          ))}

          {/* Catch-all for blog tag pages */}
          <Route path="/blog/tags/*" element={<Navigate to="/contact" replace />} />
          <Route path="/blog/page/*" element={<Navigate to="/contact" replace />} />

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      {!isChromeless && <Footer />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}

export default App;
